import { render, staticRenderFns } from "./Needs.vue?vue&type=template&id=319882ca&scoped=true"
import script from "./Needs.vue?vue&type=script&lang=js"
export * from "./Needs.vue?vue&type=script&lang=js"
import style0 from "./Needs.vue?vue&type=style&index=0&id=319882ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319882ca",
  null
  
)

export default component.exports